import { gql } from "@apollo/client";
import { CompressionService } from "./CompressionService";
import { useApolloClient } from "@apollo/client/react";
import { useCallback } from "react";

export const useGraphqlService = () => {
    const apolloClient = useApolloClient();

    const executeMutation = useCallback(async (queryValue, variables = {}) => {
        return await apolloClient.mutate({
            mutation: gql`${queryValue}`,
            variables,
        });
    }, [apolloClient]);

    const fixQueryValue = (queryValue) => {
        if (!queryValue.includes('getOptimizedSensorGraph')) return queryValue;

        let fixedQueryValue = queryValue;
        const sensorIdMatch = fixedQueryValue.match(/SENSOR_ID:\s*"([^"]+)"/);
        const sensorId = sensorIdMatch ? sensorIdMatch[1] : 'unknown';
        const intervalMatch = fixedQueryValue.match(/INTERVAL:\s*([^,\s)]+)/);

        if (intervalMatch) {
            const intervalValue = intervalMatch[1];
            if (isNaN(Number(intervalValue))) {
                console.warn(`센서 ${sensorId}의 INTERVAL 파라미터 수정: ${intervalValue} -> 15`);
                fixedQueryValue = fixedQueryValue.replace(/INTERVAL:\s*([^,\s)]+)/, 'INTERVAL: 15');
            } else if (Number(intervalValue) < 1) {
                console.warn(`센서 ${sensorId}의 INTERVAL 파라미터 수정: ${intervalValue} -> 1 (최소값)`);
                fixedQueryValue = fixedQueryValue.replace(/INTERVAL:\s*([^,\s)]+)/, 'INTERVAL: 1');
            }
        } else {
            console.warn(`센서 ${sensorId}의 INTERVAL 파라미터 없음, 기본값 15 추가`);
            fixedQueryValue = fixedQueryValue.replace(/\)\s*{/, ', INTERVAL: 15) {');
        }

        return fixedQueryValue;
    };

    // 객체를 GraphQL mutation 인자 문자열로 변환
    // string: 큰따옴표 이스케이프 처리 후 "value" 형태로 변환
    // number: 따옴표 없이 그대로 변환
    const objToQueryData = (objItem) => {
        return Object.keys(objItem).map((key) => {
            const value = objItem[key];
            if (typeof value === "string") {
                const escapedValue = value.replace(/"/g, '\\"');
                return `${key}: "${escapedValue}"`;
            } else if (typeof value === "number") {
                return `${key}: ${value}`;
            }
            return null;
        }).filter(Boolean).join(", ");
    };

    const executeQuery = useCallback (async (queryValue, variables = {}, fetchPolicy = 'network-only') => {
        const isDataQuery = queryValue.includes('getSensorData');
        const fixedQueryValue = fixQueryValue(queryValue);

        let result = await apolloClient.query({
            query: gql`${fixedQueryValue}`,
            variables,
            fetchPolicy,
            errorPolicy: 'all',
            context: { useCompression: isDataQuery },
        });

        if (isDataQuery && result.data?.getSensorData) {
            console.log("압축된 센서 데이터 수신, 압축 해제 시작");
            result = {
                ...result,
                data: {
                    ...result.data,
                    getSensorData: CompressionService.decompressSensorData(result.data.getSensorData),
                },
            };
            console.log("센서 데이터 압축 해제 완료");
        }

        return result;
    }, [apolloClient]);

    return {
        executeMutation,
        executeQuery,
        objToQueryData
    }
}